import React, { Suspense, lazy } from 'react';
import { Routes, Navigate, Route, useLocation } from 'react-router-dom';

import SiteLayout from './layouts/SiteLayout';
import MainLayout from './layouts/MainLayout';

import GuestGuard from './guards/GuestGuard';
import UserGuard from './guards/UserGuard';

import LoadingScreen from './components/LoadingScreen';
import Login from './views/auth/Login';
import Register from './views/auth/Register';
import Dashboard from './views/user/CreatorDashboard/Dashboard';

import Page404 from './views/errors/Page404';
import VerifyAccountPassword from './views/auth/ForgetPass/VerifyAccountPassword';
import ForgetPass from './views/auth/ForgetPass';
import LoginWithOtp from './views/auth/Login/LoginWithOtp';
import LandingPage from './views/auth/LandingPage';
import UnderConstruction from './views/errors/UnderConstruction';


export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>

    <Routes>
      {routes.map((route, i) => {
        const location = useLocation();
        // const Guard = route.guard || Fragment;
        // const Layout = route.layout || Fragment;
        // const Component = route.component;
        let UNAUTH_ROUTE = ["/", "/login", "/register", "/forget-pass", "/login-with-otp", "/otp-verification"]
        let AUTH_ROUTE = ["/user/dashboard", "/user/all-accounts", "/user/edit-profile", "/user/add-admin",
          "/user/change-password", "/user/help", "/user", "/user/add-staf", "/user/all-staf",
          "/user/event-list", "/user/edit-events", "/user/event-details", "/user/accountPreview",
        ]
        // console.log(location, route.path)
        return (
          // location.pathname === "/" 
          // || location.pathname === "/login" 
          // || location.pathname === "/register" 
          // || location.pathname === "/forget-pass" 
          // || location.pathname === "/otp-verification" 
          UNAUTH_ROUTE.includes(location.pathname)
            ?
            <Route
              key={i}
              path={location.pathname}
              // exact={route.exact}
              exact={true}
              element={
                <GuestGuard>
                  <SiteLayout>
                    {(
                      location.pathname === "/") ? <LandingPage />
                      : (location.pathname === "/login") ? <UnderConstruction />
                        : location.pathname === "/register" ? <UnderConstruction />
                          : location.pathname === "/forget-pass" ? <UnderConstruction />
                            : location.pathname === "/login-with-otp" ? <UnderConstruction />
                              : location.pathname === "/otp-verification" ? <UnderConstruction />
                                : ""
                    }
                  </SiteLayout>
                </GuestGuard>
              }
            />
            //   : (location.pathname.includes("/user/dashboard")
            //   || location.pathname.includes("/user")
            // )
            : AUTH_ROUTE.includes(location.pathname) ?
              <Route
                key={i}
                path={location.pathname}
                // exact={route.exact}
                exact={true}
                element={
                  <UserGuard>
                    <MainLayout>
                      {location.pathname.includes("/user/dashboard") ? <UnderConstruction />
                        // : location.pathname.includes("/user/all-accounts") ? <AllAccount />
                        : location.pathname.includes("/user") ? <UnderConstruction />
                          : <Navigate to="/404" />
                      }
                    </MainLayout>
                  </UserGuard>
                }
              />
              :
              <Route
                key={i}
                path={location.pathname}
                // exact={route.exact}
                exact={true}
                element={
                  <>
                    <>
                      <Navigate to="/404" />
                      <Page404 />
                    </>
                  </>
                }
              />
        );
      })}
    </Routes>
  </Suspense>
);

const routes = [
  // anonymous routes
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/errors/Page404'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/',
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/login',
    // component: lazy(() => import('./views/auth/Login'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/register',
    // component: lazy(() => import('./views/auth/Register'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/otp-verification',
    // component: lazy(() => import('./views/auth/ForgetPass/VerifyAccountPassword'))
  },
  {
    exact: true,
    layout: SiteLayout,
    guard: GuestGuard,
    path: '/forget-pass',
    // component: lazy(() => import('./views/auth/ForgetPass'))
  },
  {
    exact: true,
    path: '/user',
    guard: UserGuard,
    layout: MainLayout,
    component: () => <Navigate to="/user/dashboard" />
  },
  {
    exact: true,
    path: '/user/dashboard',
    guard: UserGuard,
    layout: MainLayout,
    // component: React.lazy(() => import('./views'))
  },

];

export default routes;
